import { type CurrencyValueRow } from "../campaignForm";
import CurrencyValueList from "./CurrencyValueList";

interface MinTransactionAmountFieldsProps {
  rows: CurrencyValueRow[];
  onChange: (rows: CurrencyValueRow[]) => void;
}

export default function MinTransactionAmountFields({
  rows,
  onChange,
}: MinTransactionAmountFieldsProps) {
  return (
    <div className="mt-[16px]">
      <label className="text-[14px] text-[#758089]">
        Minimum Transaction Amount (Optional)
      </label>
      <p className="mt-[4px] text-[13px] text-[#A1A1AA]">
        Set a minimum transaction amount per currency. Leave empty for no
        minimum requirement
      </p>

      <div className="mt-[12px]">
        <CurrencyValueList
          rows={rows}
          onChange={onChange}
          valueLabel="Amount"
          valuePlaceholder="e.g. 100"
        />
      </div>
    </div>
  );
}
